module.exports = __webpack_public_path__ + "static/media/orange-tick.b4e5fb73.svg";